export default {"src":"/_next/static/media/firepit.47205de2.svg","height":32,"width":31,"blurWidth":0,"blurHeight":0};